import React from "react";
import { Link } from "react-router-dom";
import EmotionalSafety from "../Img/Final-images/Emotional-Safety.jpg";
import ChildrenVoice from "../Img/Final-images/Empowering-Children-Voice.png";
import BannerImg from "../Img/Final-images/Our-approach-banner-img.png";

function OurApproch() {
  return (
    <>
      <section className="our-approc text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Our Approch</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section className="pt-5">
        <div className="container ">
          <h3 className="sub-heading text-center mb-4">
            Relationship Led and Trauma Informed
          </h3>
          <p>
            Children often arrive in residential care with complex emotional
            needs shaped by early adversity. Our approach is grounded in trauma
            informed practice and focuses on building trusting, respectful
            relationships.
          </p>
          <p>
            We understand that behavior is a form of communication. Staff
            respond in ways that promote emotional safety, reduce shame, and
            help children develop healthier coping strategies.
          </p>
        </div>
      </section>

      <section className="our-approach py-5">
        <div className="container">
          {/* Row 1 */}
          <div className="row g-6 mb-4">
            <div className="col-12 col-md-6">
              <h3 className="mb-4 sub-heading text-center text-md-start">
                Consistency and Emotional Safety
              </h3>
              <strong></strong>
              <p className="">Across all homes, we priorities</p>
              <ul className="quality-list mt-4">
                <li>Predictable routines</li>
                <li>Clear, consistent boundaries</li>
                <li>Emotionally available adults</li>
                <li>Calm, reflective responses to behavior</li>
                <li>A culture of patience, empathy, and understanding</li>
              </ul>
              <p>
                Children are supported to develop emotional regulation,
                resilience, and self esteem at a pace that feels safe for them.
              </p>
            </div>

            <div className="col-12 col-md-6 text-center">
              <img
                src={EmotionalSafety}
                alt="Emotional Safety"
                className="img-fluid rounded about-img"
              />
            </div>
          </div>

          <div className="row g-6 mb-4">
            <div className="col-12 col-md-6 text-center">
              <img
                src={ChildrenVoice}
                alt="Empowering Children Voice"
                className="img-fluid rounded about-img"
              />
            </div>
            <div className="col-12 col-md-6">
              <h3 className="mb-4 sub-heading text-center text-md-start">
                Empowering Children’s Voice
              </h3>

              <p className="">
                Children are encouraged to share their views, wishes, and
                feelings through:
              </p>

              <ul className="quality-list mt-4">
                <li>Key work sessions</li>
                <li>Children’s meetings</li>
                <li>Everyday conversations</li>
                <li>
                  Participation in decisions about their routines, activities,
                  and personal spaces
                </li>
              </ul>
              <p>
                We ensure children feel heard, respected, and involved in
                shaping their own care.
              </p>
            </div>
          </div>

          {/* Row 2 
          <div className="row align-items-center g-4">
            <div className="col-12 col-md-6 order-2 order-md-2">
              <p>
                Each home has its own Registered Manager and Statement of
                Purpose, but all homes share the same organizational ethos,
                safeguarding procedures, and quality standards. Our teams are
                committed to reflective practice, continuous improvement, and
                delivering care that meets and exceeds regulatory expectations.
              </p>
            </div>

            <div className="col-12 col-md-6 order-1 order-md-1 text-center">
              <img
                src={OurApproachimg}
                alt="Our Care Environment"
                className="img-fluid rounded about-img"
              />
            </div>
          </div>*/}
        </div>
      </section>
    </>
  );
}

export default OurApproch;
